import React, {FC} from 'react';
import styled from 'styled-components';

import {fontSizes} from '../../../../../libs/shared/ui/src/styles/fontStyles';
import {ConversationModel} from '../../../../models/api/conversationModel';
import {CommentComposerVisibilityContainer} from './commentComposerVisibilityContainer';

/*
 * Props.
 */

interface CommentComposerFooterProps {
  conversation: ConversationModel | null;
  mentionedAliases?: ReadonlyArray<string>;
  shouldHideVisibilityText: boolean | undefined;
}

/*
 * Style.
 */

const StyledDiv = styled.div`
  flex: none;
  min-height: 18px;
  padding: 2px 26px;
  padding-left: 18px;
  font-size: ${fontSizes.veryTiny};
  line-height: 14px;
`;

/*
 * Component.
 */

export const CommentComposerFooter: FC<CommentComposerFooterProps> = (props) => (
  <StyledDiv>
    {props.conversation && !props.shouldHideVisibilityText && (
      <CommentComposerVisibilityContainer
        conversation={props.conversation}
        mentionedAliases={props.mentionedAliases}
      />
    )}
  </StyledDiv>
);
